import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=33d30c6f&scoped=true"
import script from "./ShiftList.vue?vue&type=script&lang=ts"
export * from "./ShiftList.vue?vue&type=script&lang=ts"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=33d30c6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d30c6f",
  null
  
)

export default component.exports